import React from "react";
import { ArrowUpRight } from "lucide-react";
import EditableText from "./EditableText";
import { useContent } from "../context/ContentContext";

export default function Contact() {
  const { content } = useContent();
  const contact = content?.contact;
  if (!contact) return null;

  return (
    <section
      id="contact"
      className="relative bg-[#00011F] text-[#F9F8F6] pt-16 md:pt-20 pb-10 md:pb-14"
      data-testid="contact-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          {/* Left: heading + email link */}
          <div className="md:col-span-7">
            <EditableText
              path="contact.heading"
              value={contact.heading}
              as="h2"
              multiline
              className="font-serif text-[#F9F8F6] text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight font-semibold mb-8 md:mb-10 text-balance"
              testId="contact-heading"
            />

            <a
              href={`mailto:${contact.email}`}
              className="group inline-flex items-center gap-5 border-b border-[#F9F8F6]/40 hover:border-[#F9F8F6] transition-colors pb-3 pr-2 w-full max-w-md"
              data-testid="contact-email-link"
            >
              <EditableText
                path="contact.email"
                value={contact.email}
                as="span"
                className="font-sans text-[#F9F8F6]/90 text-sm md:text-base tracking-wide flex-1"
                testId="contact-email"
              />
              <ArrowUpRight
                size={16}
                strokeWidth={1.75}
                className="text-[#F9F8F6] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
          </div>

          {/* Right: address + phone */}
          <div className="md:col-span-4 md:col-start-9">
            <div className="font-serif text-[#F9F8F6] text-lg md:text-xl font-semibold mb-5">
              Address
            </div>
            {contact.country && (
              <EditableText
                path="contact.country"
                value={contact.country}
                as="div"
                className="text-[#3B5BFF] uppercase text-[11px] tracking-[0.3em] font-bold mb-3"
                testId="contact-country"
              />
            )}
            <EditableText
              path="contact.address"
              value={contact.address}
              as="div"
              multiline
              preserveWhitespace
              className="text-[#F9F8F6]/90 text-sm md:text-[15px] leading-[1.7] mb-6"
              testId="contact-address"
            />
            <a href="tel:+40374305791"
  className="text-[#F9F8F6] text-sm md:text-[15px] tracking-wide hover:text-[#C4A661] transition-colors"
  data-testid="contact-phone"
>
  {contact.phone}
</a>
          </div>
        </div>
      </div>
    </section>
  );
}
